const STATS_KEY = 'rondaybaciga_global_stats';

const DEFAULT_STATS = {
    gamesPlayed: 0,
    rondaGames: 0,
    bacigaGames: 0,
    wins: {
        total: 0,
        ronda: 0,
        baciga: 0
    },
    percentages: {
        winRate: 0,
        rondaWinRate: 0,
        bacigaWinRate: 0
    },
    actions: {
        player: {
            caidas: 0,
            contracaidas: 0,
            sanVicentes: 0,
            aseos: 0,
            rondas: 0,
            rondines: 0,
            bacigas: 0,
            bacigotes: 0,
            cosas: 0,
            las31: 0
        },
        partner: { // Assuming partner is consistently tracked as specific AI
            caidas: 0,
            contracaidas: 0,
            sanVicentes: 0,
            aseos: 0,
            rondas: 0,
            rondines: 0,
            bacigas: 0,
            bacigotes: 0,
            cosas: 0,
            las31: 0
        },
        rivals: {
            caidas: 0,
            contracaidas: 0,
            sanVicentes: 0,
            aseos: 0,
            rondas: 0,
            rondines: 0,
            bacigas: 0,
            bacigotes: 0,
            cosas: 0,
            las31: 0
        }
    },
    records: {
        maxCardsHandTeam: 0, // Max cards collected by own team in a hand
        maxCardsHandPlayer: 0, // Max cards collected by player in a hand
        lowestBacigaPlayer: 99, // Should be updated with actual baciga sum
        lowestBacigotePlayer: 99
    },
    funStats: {
        totalPointsScored: 0, // Total de puntos conseguidos por el jugador a lo largo de todas las partidas
        perfectGames: 0, // Juegos ganados 18-0
        comebacks: 0, // Victorias estando por debajo en el marcador
        totalCardsCollected: 0, // Total de cartas recogidas por el jugador
        luckiestCard: null, // Carta más recogida (formato: "5 oros")
        cardCollectionCount: {} // Conteo de cada carta recogida
    }
};

class StatisticsService {
    constructor() {
        this.stats = this.loadStats();
    }

    loadStats() {
        try {
            const stored = localStorage.getItem(STATS_KEY);
            if (stored) {
                // Merge with defaults to ensure new keys exist
                return this.deepMerge(DEFAULT_STATS, JSON.parse(stored));
            }
        } catch (e) {
            console.error('Error loading stats', e);
        }
        return JSON.parse(JSON.stringify(DEFAULT_STATS));
    }

    saveStats() {
        try {
            this.updatePercentages();
            localStorage.setItem(STATS_KEY, JSON.stringify(this.stats));
        } catch (e) {
            console.error('Error saving stats', e);
        }
    }

    updatePercentages() {
        const s = this.stats;
        s.percentages.winRate = s.gamesPlayed ? ((s.wins.total / s.gamesPlayed) * 100).toFixed(1) : 0;
        s.percentages.rondaWinRate = s.rondaGames ? ((s.wins.ronda / s.rondaGames) * 100).toFixed(1) : 0;
        s.percentages.bacigaWinRate = s.bacigaGames ? ((s.wins.baciga / s.bacigaGames) * 100).toFixed(1) : 0;
    }

    deepMerge(target, source) {
        for (const key of Object.keys(source)) {
            if (source[key] instanceof Object && key in target) {
                Object.assign(source[key], this.deepMerge(target[key], source[key]));
            }
        }
        Object.assign(target || {}, source);
        return target;
    }

    getStats() {
        return this.stats;
    }

    // --- Registration Methods ---

    registerGameStart(mode) {
        this.stats.gamesPlayed++;
        if (mode === 'ronda') this.stats.rondaGames++;
        else if (mode === 'baciga') this.stats.bacigaGames++;
        this.saveStats();
    }

    registerWin(mode) {
        this.stats.wins.total++;
        if (mode === 'ronda') this.stats.wins.ronda++;
        else if (mode === 'baciga') this.stats.wins.baciga++;
        this.saveStats();
    }

    registerAction(actionType, actor) {
        // actor: 'player', 'partner', 'rivals'
        if (this.stats.actions[actor] && this.stats.actions[actor][actionType] !== undefined) {
            this.stats.actions[actor][actionType]++;
            this.saveStats();
        }
    }

    registerPoints(points, actor) {
        // Track total points scored by player
        if (actor === 'player') {
            this.stats.funStats.totalPointsScored += points;
            this.saveStats();
        }
    }

    registerCardCollection(count, isPlayer) {
        if (isPlayer) {
            if (count > this.stats.records.maxCardsHandPlayer) {
                this.stats.records.maxCardsHandPlayer = count;
            }
            // Track total cards collected by player
            this.stats.funStats.totalCardsCollected += count;
            this.saveStats();
        }
        // Assuming team collection is handled separately or implied
        // If team collection needs to be tracked, passed isPlayer as false if it's partner
        // But prompt says "Mayor numero de cartas recogidas por una pareja".
        // Use a separate method or flag for team totals.
    }

    registerTeamCollection(count) {
        if (count > this.stats.records.maxCardsHandTeam) {
            this.stats.records.maxCardsHandTeam = count;
            this.saveStats();
        }
    }

    registerBacigaValue(value, isBacigote) {
        if (isBacigote) {
            if (value < this.stats.records.lowestBacigotePlayer) {
                this.stats.records.lowestBacigotePlayer = value;
            }
        } else {
            if (value < this.stats.records.lowestBacigaPlayer) {
                this.stats.records.lowestBacigaPlayer = value;
            }
        }
        this.saveStats();
    }
}

const statsService = new StatisticsService();
export default statsService;
